module.exports = __webpack_public_path__ + "static/img/place_5.f59c1aad.png";